import { LitElement, html, css } from '@hh/global.js'

class HHBundleItemsPicker extends LitElement {
  static properties = {}

  constructor() {
    super()

    this.triggers = this.querySelectorAll('.js-bundle-item-line-edit')
    this.overlay = document.querySelector('.js-bundle-selection-overlay')
    this.availabilityInputs = this.querySelectorAll('.js-bundle-item-available')

    this.handleEditClick = this.handleEditClick.bind(this)
  }

  connectedCallback() {
    super.connectedCallback()

    this.triggers.forEach(trigger => {
      trigger.addEventListener('click', this.handleEditClick)
    }, false)

    this.setAvailability()
  }

  disconnectedCallback() {
    super.disconnectedCallback()

    this.triggers.forEach(trigger => {
      trigger.removeEventListener('click', this.handleEditClick)
    })
  }

  handleEditClick(e) {
    e.preventDefault()

    const { target } = e
    const targetId = target?.dataset.target || ''
    this.overlay.classList.add('active')
    document.querySelector(`#${targetId}`).classList.add('active')
    document.querySelector('body').classList.add('no-scroll')
  }

  setAvailability() {
    const hasSoldoutItem = Array.from(this.availabilityInputs).some(input => input.value === 'false')

    if (hasSoldoutItem) {
      const atcButton = document.querySelector('.js-single-atc')
      const stickyAtcButton = document.querySelector('.js-sticky-atc')
      const soldoutLabel = atcButton.dataset.soldoutLabel || 'Out of stock'
      const quantityInput = document.querySelector('.js-pdp-quantity-input')
      atcButton.setAttribute('text', soldoutLabel)
      atcButton.setAttribute('disabled', '')
      if (stickyAtcButton) {
        stickyAtcButton.setAttribute('disabled', '')
        stickyAtcButton.buttonContent = soldoutLabel
      }
      quantityInput.setAttribute('disabled', '')
    }
  }

  render() {
    return html`<slot></slot>`
  }

  static styles = css``
}

customElements.define('hh-bundle-items-picker', HHBundleItemsPicker)
